import { useEffect, useState } from 'react';
import { TextBox, TextBoxComponentSpacing } from './TextBox';

interface PhoneBoxProps {
    id?: string;
    dataTestid?: string;
    value: string | undefined;
    name?: string;
    readOnly?: boolean;
    label?: string;
    helperText?: string;
    required?: boolean;
    children?: React.ReactNode;
    width?: string;
    maxLength?: number;
    onChange: (value: string) => void;
    onEnterKey?: () => void;
    onValidationEvent?: (isValid: boolean) => void;
    componentSpacing?: TextBoxComponentSpacing;
    showInfoIcon?: boolean;
    infoText?: string;
}

export const PhoneBox: React.FC<PhoneBoxProps> = ({
    id,
    dataTestid,
    value,
    readOnly = false,
    label,
    helperText,
    required = false,
    children,
    width = 'auto',
    maxLength,
    onChange,
    onEnterKey,
    onValidationEvent,
    componentSpacing,
    showInfoIcon = false,
    infoText,
}) => {
    const [currentValue, set_currentValue] = useState(value);

    const validateValue = (value: string) => {
        if (!value) return !required;

        const anyUnderscore = value.includes('_');
        return !anyUnderscore;
    };

    useEffect(() => {
        if (!value) return;

        set_currentValue(value.replace(/[^0-9]/g, ''));
    }, [value]);

    return (
        <TextBox
            id={id}
            dataTestid={dataTestid}
            value={currentValue}
            onEnterKey={onEnterKey}
            readOnly={readOnly}
            onChange={onChange}
            validateValue={validateValue}
            onValidationEvent={onValidationEvent}
            label={label}
            helperText={helperText}
            required={required}
            children={children}
            width={width}
            maxLength={maxLength}
            type='tel'
            mask='+1 (000) 000-0000'
            maskInvalidMessage='Invalid phone number'
            componentSpacing={componentSpacing}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
        />
    );
};
